<script setup>
import { ref, onMounted } from "vue"

import SearchBar from "./SearchBar.vue"
import FeedService from "../services/FeedService.js"
import { useFilteredFeedStore } from "../stores/FilteredFeed.js"

const store = useFilteredFeedStore()

const items = ref(null)

const toggled = ref(false)

onMounted(() => {
	FeedService.getTaxonomy(store.taxonomy)
		.then((response) => {
			items.value = response.data
		})
		.catch((error) => {
			console.log(error)
		})
})

function doFilter() {
	if (store.filters) {
		store.fetchItems()
	}
}
</script>

<template>
	<section id="filter">
		<div class="bg-grey py-12">
			<div class="container">
				<div class="flex flex-col gap-8">
					<div class="flex gap-8 justify-between flex-wrap">
						<p class="text-md md:text-lg font-mono inline-flex gap-2 items-center" @click="toggled = !toggled">
							<span>Filter by categories</span>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 md:hidden" :class="{ 'rotate-180' : toggled }">
								<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
							</svg>
						</p>
						<button class="submit-button py-0" v-if="Object.keys(store.filters).length !== 0" @click="store.clearFilters()">
							<span>Clear filters</span>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
								<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
							</svg>
						</button>
					</div>
					<div class="primary-menu hidden md:flex gap-4 flex-wrap" :class="{ '!flex' : toggled }">
						<button
							class="capsule-button gap-2"
							v-for="item in items"
							:key="item.id"
							@click.prevent="
								store.updateFilters({
									taxonomy: store.taxonomy,
									term: item.slug,
									name: item.name,
								})
							"
							:class="{
								'bg-blue text-white ring-0': store.inFilters(item.slug, store.taxonomy),
							}"
						>
							<span>{{ item.name }}</span>
							<svg v-if="store.inFilters(item.slug, store.taxonomy)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
								<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
							</svg>
						</button>
					</div>
					<SearchBar submit-label="Submit" />
				</div>
			</div>
		</div>
	</section>
</template>
